var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('upcoming-event',{attrs:{"isConsiderTheseEventGadget":false}}),_c('upcoming-event',{attrs:{"isConsiderTheseEventGadget":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }